module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mysection"
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "查询账号"
    },
    model: {
      value: (_vm.filters.username),
      callback: function($$v) {
        _vm.$set(_vm.filters, "username", $$v)
      },
      expression: "filters.username"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.datalist,
      "highlight-current-row": "",
      "height": "450"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "circle": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "circle": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "编号",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "账号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "password",
      "label": "密码",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "权限",
      "width": "100",
      "formatter": _vm.formatRoles
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "valid",
      "label": "状态",
      "width": "100",
      "formatter": _vm.formatValid
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.formatType(scope.row)) + "\n\t\t\t\t")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": _vm.editformtitle,
      "visible": _vm.editFormVisible,
      "before-close": _vm.clickClose,
      "size": "40%",
      "with-header": false,
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1024"
    }
  }, [_c('div', [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-main', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.editformtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "账号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.username),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "username", $$v)
      },
      expression: "editForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "企业",
      "prop": "cpcode"
    }
  }, [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "请输入/请选择"
    },
    model: {
      value: (_vm.editForm.cpcode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cpcode", $$v)
      },
      expression: "editForm.cpcode"
    }
  }, _vm._l((_vm.company_options), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name
      },
      model: {
        value: (item.code),
        callback: function($$v) {
          _vm.$set(item, "code", $$v)
        },
        expression: "item.code"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.password),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "password", $$v)
      },
      expression: "editForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "权限",
      "prop": "role"
    }
  }, [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "请输入/请选择"
    },
    model: {
      value: (_vm.editForm.role),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "role", $$v)
      },
      expression: "editForm.role"
    }
  }, _vm._l((_vm.role_options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "用户类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择用户类型"
    },
    model: {
      value: (_vm.editForm.type),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "type", $$v)
      },
      expression: "editForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "系统用户",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "业务员",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "企业用户",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.editForm.valid),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "valid", $$v)
      },
      expression: "editForm.valid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "有效",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无效",
      "value": "0"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-46c7fc08"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/role/Roleuser.vue
// module id = 646
// module chunks = 1